import { Body } from "@sprout/typography.tsx";
import CheckMarkCircleFilledIcon from "@sprout/icons/check_mark_circle_filled.tsx";
import CircleFilledIcon from "@sprout/icons/circle_filled.tsx";
import CircleIcon from "@sprout/icons/circle.tsx";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { StageStatus } from "@/types/application";

interface Props {
  name: string;
  name_key?: string | null;
  status: StageStatus;
  isLast: boolean;
}

const StageMarker = ({ status }: { status: StageStatus }) => {
  if (status === "completed") {
    return <CheckMarkCircleFilledIcon size="xs" ariaHidden />;
  }
  if (status === "current") {
    return <CircleFilledIcon size="xs" color="green-text" ariaHidden />;
  }
  return <CircleIcon size="xs" ariaHidden />;
};

export const StageTimelineCard = ({ name, name_key, status, isLast }: Props) => {
  const { t } = useTranslation("applications");
  const displayName = name_key ? t(`stage_names.${name_key}`, name) : name;

  return (
    <div className="flex gap-3">
      <div className="stages-timeline__marker flex flex-col items-center pt-1">
        <StageMarker status={status} />
        {!isLast && (
          <div
            className={classNames(
              "flex-1 w-px -mb-1",
              status === "completed" ? "bg-green-700" : "bg-gray-700",
            )}
          />
        )}
      </div>
      <Body
        medium={status === "current"}
        className={classNames({
          "!pb-4": !isLast,
          "!text-gray-800": status === "upcoming",
        })}
      >
        {displayName}
      </Body>
      <span className="sr-only">{t(`stage_status.${status}`)}</span>
    </div>
  );
};
